import { lazy } from "react";

export const importView = (name) => {
  return lazy(() =>
    import(/* webpackChunkName: "cust-[request]" */ `modules/ba/views/${name}`)
  );
};
